module.exports = __webpack_public_path__ + "img/notice.7720b77f.png";